import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api, errMsg } from "../lib/api";
import { toast } from "sonner";
import { Clock, Loader2 } from "lucide-react";

const pad = (n) => String(n).padStart(2, "0");

const TrialBanner = () => {
  const { user, refresh } = useAuth();
  const [nowTs, setNow] = useState(Date.now());
  const [busy, setBusy] = useState(false);
  const isTrial = user && user.plan === "trial" && user.has_access && user.plan_expires;

  useEffect(() => {
    if (!isTrial) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [isTrial]);

  const left = isTrial ? new Date(user.plan_expires).getTime() - nowTs : 0;
  useEffect(() => { if (isTrial && left <= 0) refresh(); }, [isTrial, left, refresh]);
  if (!isTrial || left <= 0) return null;

  const s = Math.floor(left / 1000);
  const d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;

  const upgrade = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", { plan_id: "monthly", origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) {
      toast.error(errMsg(e, "Could not start checkout."));
      setBusy(false);
    }
  };

  return (
    <div className={`trial-banner ${s < 6 * 3600 ? "urgent" : ""}`} data-testid="trial-banner">
      <div className="tb-left">
        <Clock size={14} />
        <span>Trial ends in</span>
        <div className="tb-clock" data-testid="trial-countdown">
          <b>{d}</b><small>d</small><b>{pad(h)}</b><small>h</small><b>{pad(m)}</b><small>m</small><b>{pad(sec)}</b><small>s</small>
        </div>
      </div>
      <button className="tb-btn" onClick={upgrade} disabled={busy} data-testid="trial-upgrade-btn">
        {busy ? <><Loader2 size={12} className="spin" /> Opening checkout…</> : "Upgrade to Monthly — $79/mo →"}
      </button>
    </div>
  );
};

export default TrialBanner;
